<template>
  <v-card class="pa-4" outlined elevation="8" id="document-to-convert">
    <v-row>
      <v-col>
        <v-card class="mx-auto px-2 py-0" max-width="450">
          <v-form v-model="form">
            <v-row>
              <v-col cols="8" sm="8" md="8" class="pr-1 py-1 mt-4">
                <v-text-field
                  v-model="lastYear"
                  label="Manuel (N-1)"
                  clearable
                  suffix="%"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" class="px-0 py-1 mt-4">
                <v-checkbox
                  v-model="lastYearCheckbox"
                  @update:modelValue="updateCheckbox('lastYear')"
                  label="Active"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" sm="8" md="8" class="pr-1 py-1">
                <v-text-field
                  v-model="calculated"
                  label="Calcul YTD N"
                  clearable
                  suffix="%"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" class="px-0 py-1">
                <v-checkbox
                  v-model="calculatedCheckbox"
                  @update:modelValue="updateCheckbox('calculated')"
                  label="Active"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center mb-1">
                <v-btn
                  color="#ffb500"
                  class="text-white"
                  @click="exportToPDF"
                  rounded="lg"
                  border
                >
                  Exporter en PDF
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="4" sm="12" :md="4">
        <v-row no-gutters>
          <v-col>
            <v-card class="pa-4 d-flex justify-center align-center" outlined>
              <div>
                <h2 class="text-h3 font-weight-black text-color text-center">
                  {{ Math.ceil(totalProjectedPoints).toLocaleString("fr-FR") }}
                </h2>
                <div class="text-body-2 mt-2 text-center">
                  Nombre de points projetés sur l'année
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="pt-4">
          <v-col>
            <v-card class="pa-4 d-flex justify-center align-center" outlined>
              <div>
                <h2 class="text-h3 font-weight-black text-color text-center">
                  {{
                    Math.ceil(
                      cogsSelected(totalProjectedPoints),
                    ).toLocaleString("fr-FR")
                  }}
                  €
                </h2>
                <div class="text-body-2 mt-2 text-center">
                  Cotisations annuelles projetées
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="8" sm="12" md="8">
        <v-row>
          <v-col>
            <v-sheet class="mx-auto" rounded="xl" border>
              <div class="pa-4">
                <div class="text-subtitle-1">Split points par Franchise</div>
                <v-responsive class="overflow-y-auto" max-height="280">
                  <v-chip-group class="mt-3" column>
                    <v-chip
                      v-for="franchise in provisionItemsFiltered"
                      :key="franchise"
                    >
                      <span class="text-subtitle-2 color-text">
                        {{ franchise.franchise.name }}
                      </span>
                      <span
                        class="text-subtitle-2 ml-1"
                        v-if="franchise.projectedPoint > 0"
                      >
                        :
                        {{
                          Math.round(franchise.projectedPoint).toLocaleString(
                            "fr-FR",
                          )
                        }}
                        pts
                      </span>
                      <span v-else class="text-subtitle-2 ml-1 text-red">
                        :
                        {{
                          Math.round(franchise.projectedPoint).toLocaleString(
                            "fr-FR",
                          )
                        }}
                        pts
                      </span>
                    </v-chip>
                  </v-chip-group>
                </v-responsive>
              </div>
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-sheet class="mx-auto" rounded="xl" border>
              <div class="pa-4">
                <div class="text-subtitle-1">Split coût par Franchise</div>
                <v-responsive class="overflow-y-auto" max-height="280">
                  <v-chip-group class="mt-3" column>
                    <v-chip
                      v-for="franchise in provisionItemsFiltered"
                      :key="franchise"
                    >
                      <span class="text-subtitle-2 color-text">
                        {{ franchise.franchise.name }}
                      </span>

                      <span
                        class="text-subtitle-2 ml-1"
                        v-if="franchise.projectedPoint > 0"
                      >
                        :
                        {{
                          Math.round(
                            cogsSelected(franchise.projectedPoint),
                          ).toLocaleString("fr-FR")
                        }}
                        €
                      </span>

                      <span v-else class="text-subtitle-2 ml-1 text-red">
                        :
                        {{
                          Math.round(
                            cogsSelected(franchise.projectedPoint),
                          ).toLocaleString("fr-FR")
                        }}
                        €
                      </span>
                    </v-chip>
                  </v-chip-group>
                </v-responsive>
              </div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4" sm="12" :md="4"> </v-col>
    </v-row>
    <v-row class="page-break-before">
      <v-col cols="11" class="text-center">
        <v-text-field
          v-model="search"
          label="Rechercher"
          :prepend-inner-icon="mdiMagnify"
          variant="outlined"
          hide-details
          single-line
        ></v-text-field>
      </v-col>
      <v-col cols="1" class="text-center">
        <v-tooltip
          text="Utiliser les pourcentages de l'année en cours"
          location="top"
        >
          <template v-slot:activator="{ props }">
            <!-- <v-btn
              color="#ffb500"
              class="text-white"
              @click="franchiseDialogOpen"
              :icon="mdiPlus"
              v-bind="props"
            >
            </v-btn> -->
            <v-switch
              v-model="useCurrentYearOrNot"
              v-bind="props"
              hide-details
              inset
              color="#ffb500"
            ></v-switch>
          </template>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" md="6" sm="12">
        <v-card title="Utilisation des points" flat>
          <v-data-table
            :headers="headersUsePoints"
            :items="provisionItems"
            :search="search"
            density="compact"
            items-per-page="-1"
            hide-default-footer
          >
            <template v-slot:item.franchise.name="{ item }">
              <v-chip>
                <span class="text-subtitle-2 color-text">
                  {{ item.franchise.name }}
                </span>
              </v-chip>
            </template>

            <template v-slot:item.percantagePreviousYear="{ item }">
              <v-text-field
                v-model="item.percantagePreviousYear"
                type="number"
                min="0"
                max="100"
                hide-details
                single-line
                density="compact"
                variant="plain"
                style="justify-items: center"
              ></v-text-field>
            </template>

            <template v-slot:item.percentageByCostPreviousYear="{ item }">
              <span class="text-subtitle-2 cost-text">
                {{ (item.percentageByCostPreviousYear || 0).toFixed(2) }} %
              </span>
            </template>

            <template v-slot:item.percentageByCostCurrentYear="{ item }">
              <span class="text-subtitle-2 cost-text">
                {{ (item.percentageByCostCurrentYear || 0).toFixed(2) }} %
              </span>
            </template>

            <template v-slot:tfoot>
              <tr class="bg-grey-lighten-4">
                <td class="font-weight-bold pl-4">Total :</td>
                <td class="text-center">
                  {{ getTotalValueFormatted("percantagePreviousYear") }} %
                </td>
                <td class="text-center pl-4">
                  {{ getTotalValueFormatted("percantageCurrentYear") }} %
                </td>
                <td class="text-center cost-text">
                  {{
                    getTotalValueFormattedWithDecimals(
                      "percentageByCostPreviousYear",
                    )
                  }}
                  %
                </td>
                <td class="text-center cost-text">
                  {{
                    getTotalValueFormattedWithDecimals(
                      "percentageByCostCurrentYear",
                    )
                  }}
                  %
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="6" md="6" sm="12">
        <v-card title="Projection COGS des produits gratuits" flat>
          <v-data-table
            :headers="headersCogsProjection"
            :items="provisionItems"
            :search="search"
            density="compact"
            items-per-page="-1"
            hide-default-footer
          >
            <template v-slot:item.franchise.name="{ item }">
              <v-chip>
                <span class="text-subtitle-2 color-text"
                  >{{ item.franchise.name }}
                </span>
              </v-chip>
            </template>

            <template v-slot:item.cogsProjected="{ item }">
              {{
                Math.round(
                  yearlyProjectedAmount *
                    ((useCurrentYearOrNot
                      ? item.percantageCurrentYear
                      : item.percantagePreviousYear) /
                      100),
                ).toLocaleString("fr-FR")
              }}
              €
            </template>

            <template v-slot:item.calculatedCogs="{ item }">
              <span class="text-subtitle-1 cost-text">
                {{
                  Math.round(
                    yearlyProjectedAmount *
                      ((useCurrentYearOrNot
                        ? item.percentageByCostCurrentYear
                        : item.percentageByCostPreviousYear) /
                        100),
                  ).toLocaleString("fr-FR")
                }}
                €
              </span>
            </template>

            <template v-slot:tfoot>
              <tr class="bg-grey-lighten-4">
                <td class="font-weight-bold pl-4">Total :</td>
                <td class="text-left pl-4">
                  {{ getTotalValueFormattedComputedCogsProjected }} €
                </td>
                <td class="text-left cost-text">
                  {{ getTotalValueFormattedComputedCalculatedCogs }} €
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card title="Provisions annuelles projetées" flat>
          <v-data-table
            :headers="headersEstimatedCogs"
            :items="provisionItems"
            :search="search"
            density="compact"
            items-per-page="-1"
            hide-default-footer
          >
            <template v-slot:item.franchise.name="{ item }">
              <v-chip>
                <span class="text-subtitle-2 color-text">
                  {{ item.franchise.name }}
                </span>
              </v-chip>
            </template>

            <template v-slot:item.calculatedCogs="{ item }">
              <span class="text-subtitle-1">
                {{
                  Math.round(cogsSelected(item.projectedPoint)).toLocaleString(
                    "fr-FR",
                  )
                }}
                € -
                {{
                  Math.round(
                    yearlyProjectedAmount *
                      ((useCurrentYearOrNot
                        ? item.percantageCurrentYear
                        : item.percantagePreviousYear) /
                        100),
                  ).toLocaleString("fr-FR")
                }}
                € =
              </span>
              <span class="text-subtitle-1 color-text">
                {{
                  Math.round(
                    cogsSelected(item.projectedPoint) -
                      yearlyProjectedAmount *
                        ((useCurrentYearOrNot
                          ? item.percantageCurrentYear
                          : item.percantagePreviousYear) /
                          100),
                  ).toLocaleString("fr-FR")
                }}
              </span>
              €
            </template>

            <template v-slot:item.calculatedCogsAccurate="{ item }">
              <span class="text-subtitle-1 cost-text">
                {{
                  Math.round(cogsSelected(item.projectedPoint)).toLocaleString(
                    "fr-FR",
                  )
                }}
                € -
                {{
                  Math.round(
                    yearlyProjectedAmount *
                      ((useCurrentYearOrNot
                        ? item.percentageByCostCurrentYear
                        : item.percentageByCostPreviousYear) /
                        100),
                  ).toLocaleString("fr-FR")
                }}
                € =
              </span>
              <span class="text-subtitle-1 color-text">
                {{
                  Math.round(
                    cogsSelected(item.projectedPoint) -
                      yearlyProjectedAmount *
                        ((useCurrentYearOrNot
                          ? item.percentageByCostCurrentYear
                          : item.percentageByCostPreviousYear) /
                          100),
                  ).toLocaleString("fr-FR")
                }}
              </span>
              €
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <franchise-dialog
      @close="closeFranchiseDialog"
      :dialog="modelFranchiseDialog"
    >
    </franchise-dialog>
  </v-card>
</template>

<script>
import { mdiMagnify, mdiPlus } from "@mdi/js";
import { mapState } from "vuex";
import FranchiseDialog from "@/components/kpi/FranchiseDialog.vue";

export default {
  name: "CogsKpi",
  components: {
    FranchiseDialog,
  },
  data() {
    return {
      mdiMagnify,
      mdiPlus,
      search: "",
      form: false,
      lastYearCheckbox: true,
      calculatedCheckbox: false,
      useCurrentYearOrNot: false,
      debounceTimeout: null,
      modelFranchiseDialog: false,
    };
  },
  computed: {
    ...mapState({
      provisionItems: (state) => state.kpi.provisionsItems,
      totalProjectedPoints: (state) => state.kpi.totalProjectedPoints,
      selectedYear: (state) => state.kpi.selectedYear,
      selectedMonth: (state) => state.kpi.selectedMonth,
      historizedPeriods: (state) => state.kpi.historizedPeriods,
      configurationItems: (state) => state.kpi.configurationItems,
    }),
    /**
     * Vérifie si la période sélectionnée est historisée
     */
    isHistorized() {
      if (!this.historizedPeriods || this.historizedPeriods.length === 0) {
        return false;
      }

      return this.historizedPeriods.some((period) => {
        if (this.selectedMonth) {
          return (
            period.year === this.selectedYear &&
            period.month === this.selectedMonth
          );
        } else {
          return period.year === this.selectedYear && period.month === null;
        }
      });
    },
    calculated: {
      /**
       * Retourne l'objet de configuration dont le nom est 'CalculatedCogs'.
       * @returns {Object|null} L'objet de configuration ou null s'il n'existe pas.
       */
      get() {
        const items = this.configurationItems;
        if (!Array.isArray(items)) return null;
        const found = items.find((item) => item.name === "CalculatedCogs");
        return found ? found.value : null;
      },
      set() {
        //
      },
    },

    lastYear: {
      /**
       * Retourne l'objet de configuration dont le nom est 'ManualCogs'.
       * @returns {Object|null} L'objet de configuration ou null s'il n'existe pas.
       */
      get() {
        const items = this.configurationItems;
        if (!Array.isArray(items)) return null;
        const found = items.find((item) => item.name === "ManualCogs");
        return found ? found.value : null;
      },
      set(value) {
        // Validation : accepte uniquement les nombres (entier ou décimal, séparateur . ou ,)
        const regex = /^(\d+([.,]\d*)?)?$/;
        if (!regex.test(value)) return;

        // Remplace la virgule par un point pour la cohérence
        const normalizedValue =
          typeof value === "string" ? value.replace(",", ".") : value;

        // Debounce : attend 500ms après la dernière frappe
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
          if (normalizedValue !== "" && !isNaN(Number(normalizedValue))) {
            this.$store.dispatch("kpi/updateManualCogs", {
              value: normalizedValue,
            });
          }
        }, 500);
      },
    },
    provisionItemsFiltered() {
      var provisionItemsFiltedred = [];
      this.provisionItems.forEach((item) => {
        // if (item.projectedPoint > 0) {
        provisionItemsFiltedred.push(item);
        // }
      });
      return provisionItemsFiltedred;
    },
    yearlyProjectedAmount() {
      const rate = this.calculatedCheckbox ? this.calculated : this.lastYear;
      return this.totalProjectedPoints * (rate / 100);
    },
    headersUsePoints() {
      return [
        { title: "Franchise", key: "franchise.name" },
        {
          title: "Pourcentage manuel (N - 1)",
          key: "percantagePreviousYear",
          align: "center",
        },
        {
          title: "Pourcentage actuel YTD (N)",
          key: "percantageCurrentYear",
          align: "center",
        },
        {
          title: "% Coûts (N - 1)",
          key: "percentageByCostPreviousYear",
          align: "center",
        },
        {
          title: "% Coûts YTD (N)",
          key: "percentageByCostCurrentYear",
          align: "center",
        },
      ];
    },
    headersCogsProjection() {
      return [
        { title: "Franchise", key: "franchise.name" },
        { title: "COGS N projetés", key: "cogsProjected" },
        { title: "Coûts calculés", key: "calculatedCogs" },
      ];
    },
    headersEstimatedCogs() {
      return [
        { title: "Franchise", key: "franchise.name" },
        {
          title: "Cotisation - COGS produits gratuits",
          key: "calculatedCogs",
        },
        {
          title: "Cotisation - COGS calculés",
          key: "calculatedCogsAccurate",
        },
      ];
    },
    // Total format for the computed cogsProjected column
    getTotalValueFormattedComputedCogsProjected() {
      const total = this.provisionItems.reduce((acc, item) => {
        const value = Math.round(
          this.yearlyProjectedAmount *
            ((this.useCurrentYearOrNot
              ? item.percantageCurrentYear
              : item.percantagePreviousYear) /
              100),
        );
        return acc + (isNaN(Number(value)) ? 0 : Number(value));
      }, 0);
      return Math.ceil(total).toLocaleString("fr-FR");
    },
    getTotalValueFormattedComputedCalculatedCogs() {
      const total = this.provisionItems.reduce((acc, item) => {
        const value = Math.round(
          this.yearlyProjectedAmount *
            ((this.useCurrentYearOrNot
              ? item.percentageByCostCurrentYear
              : item.percentageByCostPreviousYear) /
              100),
        );
        return acc + (isNaN(Number(value)) ? 0 : Number(value));
      }, 0);
      return Math.ceil(total).toLocaleString("fr-FR");
    },
  },
  watch: {},
  methods: {
    /**
     * Exporte les provisions au format PDF via l'endpoint backend.
     * Calcule toutes les données nécessaires et les envoie au backend.
     * @returns {Promise<void>}
     */
    async exportToPDF() {
      try {
        this.$store.commit("setOverlay", true);

        // Validation des données
        if (!this.provisionItems || this.provisionItems.length === 0) {
          throw new Error("Aucune donnée de provision disponible.");
        }

        // Calculer le totalCost (somme des coûts projetés de toutes les franchises)
        const totalCost = this.provisionItems.reduce((sum, item) => {
          return sum + this.cogsSelected(item.projectedPoint);
        }, 0);

        // Construire les données des franchises
        const franchises = this.provisionItems.map((item) => {
          const projectedCost = this.cogsSelected(item.projectedPoint);

          // COGS projetés (basé sur les pourcentages d'utilisation)
          const cogsProjected = Math.round(
            this.yearlyProjectedAmount *
              ((this.useCurrentYearOrNot
                ? item.percantageCurrentYear
                : item.percantagePreviousYear) /
                100),
          );

          // COGS calculés (basé sur les pourcentages de coûts)
          const cogsCalculated = Math.round(
            this.yearlyProjectedAmount *
              ((this.useCurrentYearOrNot
                ? item.percentageByCostCurrentYear
                : item.percentageByCostPreviousYear) /
                100),
          );

          return {
            franchiseName: item.franchise.name,
            projectedPoint: item.projectedPoint,
            projectedCost: Math.round(projectedCost),
            percentagePreviousYear: item.percantagePreviousYear || 0,
            percentageCurrentYear: item.percantageCurrentYear || 0,
            percentageByCostPreviousYear:
              item.percentageByCostPreviousYear || 0,
            percentageByCostCurrentYear: item.percentageByCostCurrentYear || 0,
            cogsProjected: cogsProjected,
            cogsCalculated: cogsCalculated,
            provisionProjected: Math.round(projectedCost - cogsProjected),
            provisionCalculated: Math.round(projectedCost - cogsCalculated),
          };
        });

        // Construire l'objet ProvisionExportDto
        const provisionData = {
          year: this.selectedYear,
          totalPointsProjected: Math.ceil(this.totalProjectedPoints),
          totalCost: Math.ceil(totalCost),
          manualCogs: parseFloat(this.lastYear) || 0,
          calculatedCogs: parseFloat(this.calculated) || 0,
          useCalculatedCogs: this.calculatedCheckbox,
          franchises: franchises,
        };

        // Appeler l'action du store pour exporter
        const response = await this.$store.dispatch(
          "kpi/exportProvisionsToPdf",
          provisionData,
        );

        // Créer un blob et télécharger le PDF
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // Récupérer le nom du fichier depuis les headers ou utiliser un nom par défaut
        link.download =
          response.headers["content-disposition"]
            ?.split("filename=")[1]
            ?.replace(/"/g, "") ||
          `Provisions_${this.selectedYear}_${
            new Date().toISOString().split("T")[0]
          }.pdf`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$store.commit("setOverlay", false);

        // Message de succès
        this.$store.dispatch("showSnackbar", {
          message: "PDF exporté avec succès",
          color: "success",
        });
      } catch (error) {
        this.$store.commit("setOverlay", false);

        // Gestion des erreurs avec messages appropriés
        let errorMessage = "Erreur lors de l'export PDF";
        if (error.response) {
          switch (error.response.status) {
            case 400:
              errorMessage =
                error.response.data?.error || "Données de provision invalides.";
              break;
            case 403:
              errorMessage =
                "Droits insuffisants pour exporter les provisions.";
              break;
            case 500:
              errorMessage =
                "Erreur serveur lors de la génération du PDF. Veuillez réessayer.";
              break;
            default:
              errorMessage =
                error.response.data?.error || "Erreur lors de l'export PDF";
          }
        } else if (error.message) {
          errorMessage = error.message;
        }

        this.$store.dispatch("showSnackbar", {
          message: errorMessage,
          color: "error",
        });
      }
    },
    updateSwitch() {
      // Inverse l'état de useCurrentYearOrNot
      this.useCurrentYearOrNot = !this.useCurrentYearOrNot;

      // Met à jour la configuration dans le store
      this.$store.dispatch("kpi/updateUseCurrentYear", {
        value: this.useCurrentYearOrNot,
      });
    },
    updateCheckbox(type) {
      if (type === "lastYear") {
        this.calculatedCheckbox = !this.lastYearCheckbox;

        // Ne faire l'appel API que si la période n'est pas historisée
        if (!this.isHistorized) {
          this.$store.commit("setOverlay", true);
          const data = {
            name: "UseCalculatedCogs",
            value: "false",
          };

          this.$store
            .dispatch("kpi/updateUseCurrentYearOrNot", data)
            .then(() => {
              this.$store.commit("setOverlay", false);
            })
            .catch(() => {
              this.$store.commit("setOverlay", false);
            });
        }
      } else if (type === "calculated") {
        this.lastYearCheckbox = !this.calculatedCheckbox;

        // Ne faire l'appel API que si la période n'est pas historisée
        if (!this.isHistorized) {
          this.$store.commit("setOverlay", true);
          const data = {
            name: "UseCalculatedCogs",
            value: "true",
          };

          this.$store
            .dispatch("kpi/updateUseCurrentYearOrNot", data)
            .then(() => {
              this.$store.commit("setOverlay", false);
            })
            .catch(() => {
              this.$store.commit("setOverlay", false);
            });
        }
      }
    },
    cogsSelected(points) {
      if (this.lastYearCheckbox) {
        return points * (this.lastYear / 100);
      } else {
        return points * (this.calculated / 100);
      }
    },
    /**
     * Calcule la somme totale d'une propriété spécifique sur tous les éléments de provisionItems
     * @param {string} property - La propriété à totaliser (gère les propriétés imbriquées 'franchise.name')
     * @returns {number|string} - Le total calculé ou '-' pour les propriétés non numériques ou imbriquées
     */
    getTotalValue(property) {
      // Gestion des propriétés imbriquées comme 'franchise.name' : retourne '-' (non applicable)
      if (property.includes(".")) return "-";

      return this.provisionItems.reduce((acc, item) => {
        const value = item[property];
        // Convertir en nombre si possible
        const numeric = Number(value);
        return acc + (isNaN(numeric) ? 0 : numeric);
      }, 0);
    },
    /**
     * Retourne la valeur totale formatée pour l'affichage
     * @param {string} property - La propriété à totaliser
     * @returns {string} - Le total formaté en français
     */
    getTotalValueFormatted(property) {
      const total = this.getTotalValue(property);
      if (total === "-") return "-";
      return Math.ceil(total).toLocaleString("fr-FR");
    },
    /**
     * Retourne la valeur totale formatée avec 2 décimales
     * @param {string} property - La propriété à totaliser
     * @returns {string} - Le total formaté avec 2 décimales
     */
    getTotalValueFormattedWithDecimals(property) {
      const total = this.getTotalValue(property);
      if (total === "-") return "-";
      return total.toFixed(2);
    },
    franchiseDialogOpen() {
      this.modelFranchiseDialog = true;
    },
    closeFranchiseDialog() {
      this.modelFranchiseDialog = false;
    },
  },
};
</script>

<style>
.color-text {
  color: #ffb500;
}

/* Styling pour les colonnes de pourcentages basés sur les coûts */
.cost-text {
  color: #1976d2;
  font-weight: 500;
}

/* Alignement des tableaux avec scroll horizontal */
.table-with-horizontal-scroll {
  overflow-x: auto;
  white-space: nowrap;
}

.table-with-horizontal-scroll .v-data-table__wrapper table th,
.table-with-horizontal-scroll .v-data-table__wrapper table td,
.table-with-horizontal-scroll .v-data-table__wrapper table tfoot td {
  min-width: 130px;
}

/* Classe pour l'état de préparation du PDF en mode paysage */
body.preparing-pdf-export .v-btn,
body.preparing-pdf-export .v-text-field,
body.preparing-pdf-export .v-checkbox,
body.preparing-pdf-export .v-switch,
body.preparing-pdf-export .v-tooltip {
  display: none !important;
}

body.preparing-pdf-export #document-to-convert {
  background-color: white !important;
  width: auto !important;
  max-width: none !important;
  padding: 8px !important;
  overflow: visible !important;
}

/* Optimisation de l'affichage pour le format paysage */
body.preparing-pdf-export .v-card {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
  page-break-inside: avoid !important;
}

body.preparing-pdf-export .v-sheet {
  border: 1px solid #e0e0e0 !important;
}

body.preparing-pdf-export .v-responsive {
  max-height: none !important;
  overflow: visible !important;
}

/* Réduire la taille des éléments pour tout faire tenir */
body.preparing-pdf-export .text-h3 {
  font-size: 16px !important;
}

body.preparing-pdf-export .text-subtitle-1 {
  font-size: 11px !important;
}

body.preparing-pdf-export .text-subtitle-2 {
  font-size: 9px !important;
}

body.preparing-pdf-export .text-body-2 {
  font-size: 9px !important;
}

/* Préserver la mise en page d'origine pour le format paysage */
body.preparing-pdf-export .v-data-table {
  font-size: 9px !important;
}

body.preparing-pdf-export .v-data-table th,
body.preparing-pdf-export .v-data-table td {
  padding: 3px 6px !important;
  font-size: 9px !important;
  white-space: nowrap !important;
}

body.preparing-pdf-export .v-chip {
  font-size: 9px !important;
  height: auto !important;
  padding: 3px 6px !important;
  margin: 2px !important;
}

body.preparing-pdf-export .pa-4 {
  padding: 8px !important;
}

body.preparing-pdf-export .v-card-title {
  font-size: 12px !important;
  padding: 8px !important;
}

/* Styles spécifiques pour l'export PDF */
@media print {
  .v-card {
    page-break-inside: avoid;
    box-shadow: none !important;
    border: 1px solid #e0e0e0;
  }

  .v-sheet {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .v-row {
    page-break-inside: avoid;
  }

  .text-h3 {
    font-size: 18pt !important;
  }

  .text-subtitle-1 {
    font-size: 14pt !important;
    font-weight: 600;
  }

  .text-subtitle-2 {
    font-size: 12pt !important;
  }

  .text-body-2 {
    font-size: 11pt !important;
  }

  .v-chip {
    border: 1px solid #e0e0e0 !important;
    margin: 2px !important;
  }

  .v-data-table {
    border-collapse: collapse;
  }

  .v-data-table th,
  .v-data-table td {
    border: 1px solid #e0e0e0 !important;
    padding: 6px !important;
  }

  /* Cacher les éléments inutiles pour l'impression */
  .v-btn,
  .v-text-field,
  .v-checkbox,
  .v-switch {
    display: none !important;
  }
}
</style>
